export default __webpack_public_path__ + "static/color-1-dfb6d13fc9477c47d8753757bc26bc9f.png";